import { Col, Divider, Form, Row, Select } from 'antd';
import DropdownIcon from 'assets/icons/simulate-dropdown.svg';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormRadio } from 'presentation/components/form/FormRadio.component';
import { FormSelect } from 'presentation/components/form/FormSelect.component';
import { FormTextArea } from 'presentation/components/form/FormTextArea.component';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

const YES_NO_OPTIONS = [
    {
        label: 'あり',
        value: 1,
    },
    {
        label: 'なし',
        value: 0,
    },
];

const YES_NO_OPTIONS_DEPEND = [
    {
        label: 'あり',
        value: '10',
    },
    {
        label: 'なし',
        value: '20',
    },
];

const optionYear = Array.from(Array(51).keys()).map((item) => {
    return {
        label: item,
        value: item,
    };
});

const optionMonth = Array.from(Array(13).keys()).map((item) => {
    return {
        label: item,
        value: item,
    };
});

interface props {
    masterData: any;
    form: any;
    changeBtnDisable: (isError?: boolean) => void;
    requiredOther1: boolean;
    requiredOther2: boolean;
    setRequiredOther1: (value: boolean) => void;
    setRequiredOther2: (value: boolean) => void;
    requiredDependent: boolean;
    setRequiredDependent: (value: boolean) => void;
    requiredRelation: boolean;
    setRequiredRelation: (value: boolean) => void;
}

export const RegistrationStepOne = ({
    masterData,
    form,
    changeBtnDisable,
    requiredOther1,
    requiredOther2,
    setRequiredOther1,
    setRequiredOther2,
    requiredDependent,
    setRequiredDependent,
    requiredRelation,
    setRequiredRelation,
}: props) => {
    return (
        <>
            <Row className="min-w-min">
                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">自宅</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="郵便番号（ハイフンなし）"
                                name="postalCode"
                                required
                                maxLength={7}
                                formatNumber={false}
                                type="number"
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="住所"
                                name="address"
                                required
                                maxLength={100}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">勤務先</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="勤務先名称"
                                name="workplaceName"
                                required
                                maxLength={100}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="勤務先の郵便番号（ハイフンなし）"
                                name="workplacePostalCode"
                                required
                                type="postcode"
                                maxLength={7}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="勤務先の所在地"
                                name="workplaceAddress"
                                required
                                maxLength={100}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="勤務先での役職"
                                name="workplaceRole"
                                required
                                maxLength={100}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="勤務先の連絡先（ハイフンなし）"
                                name="workplacePhoneNumber01"
                                required
                                type="phone"
                                maxLength={12}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <span className="content-step-form label-step-form">
                                勤続年数<span style={{ color: '#EB5757' }}>*</span>
                            </span>
                            <Row>
                                <Col span={10}>
                                    <Form.Item name="workplaceServiceYears">
                                        <Select
                                            size="large"
                                            className="select-custom "
                                            defaultValue={0}
                                            suffixIcon={
                                                <img src={DropdownIcon} alt="dropdown icon" />
                                            }
                                            options={optionYear}
                                            placeholder={PLACEHOLDER.SELECT}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col
                                    span={2}
                                    className="flex justify-center min-w-fit my-[5px] mt-[12px] "
                                >
                                    年
                                </Col>
                                <Col span={9}>
                                    <Form.Item name="workplaceServiceMonths">
                                        <Select
                                            size="large"
                                            className="select-custom"
                                            defaultValue={0}
                                            options={optionMonth}
                                            suffixIcon={
                                                <img src={DropdownIcon} alt="dropdown icon" />
                                            }
                                            placeholder={PLACEHOLDER.SELECT}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col
                                    span={3}
                                    className="flex justify-center min-w-fit my-[5px] mt-[12px] "
                                >
                                    ヶ月
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="直近の年収"
                                name="annualIncome"
                                type="number"
                                required
                                maxLength={7}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">家族</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormRadio
                                label="配偶者"
                                name="existFlagRelation"
                                options={YES_NO_OPTIONS}
                                required
                                labelClassName="content-step-form label-step-form"
                                onChange={(e) => {
                                    setRequiredRelation(e == '1');
                                }}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormRadio
                                label="配偶者の扶養義務"
                                name="dependentType"
                                options={YES_NO_OPTIONS_DEPEND}
                                required={requiredRelation}
                                disabled={!requiredRelation}
                                labelClassName="content-step-form label-step-form"
                                onChange={(e) => {
                                    setRequiredDependent(requiredRelation && e == '10');
                                }}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="子供"
                                name="count01"
                                required={requiredRelation && requiredDependent}
                                type="number"
                                maxLength={2}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                                currentForm={form}
                                onValidateError={changeBtnDisable}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="扶養の子供"
                                name="dependentCountChild"
                                required={requiredRelation && requiredDependent}
                                type="number"
                                maxLength={2}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                                currentForm={form}
                                onValidateError={changeBtnDisable}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="同居している子供"
                                name="livingTogetherCount"
                                required={requiredRelation && requiredDependent}
                                type="number"
                                maxLength={2}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                                currentForm={form}
                                onValidateError={changeBtnDisable}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="扶養している父母"
                                name="dependentCountParent"
                                required={requiredRelation && requiredDependent}
                                type="number"
                                maxLength={2}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                                currentForm={form}
                                onValidateError={changeBtnDisable}
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">その他</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormSelect
                                options={
                                    masterData?.[
                                        MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION
                                    ]
                                }
                                label="自宅の建物区分"
                                required
                                name="homeBuildingType"
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormSelect
                                options={
                                    masterData?.[
                                        MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION
                                    ]
                                }
                                label="自宅の所有区分"
                                name="homePossessionType"
                                required
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="住宅ローン残債"
                                name="housingLoanBalance"
                                type="number"
                                required
                                maxLength={9}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormRadio
                                options={YES_NO_OPTIONS}
                                required
                                label="投資用不動産"
                                name="existFlagProperty"
                                labelClassName="content-step-form label-step-form"
                                onChange={(e) => {
                                    setRequiredOther1(e == '1');
                                }}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="区分マンション（戸数）"
                                name="quantity01"
                                type="number"
                                required={requiredOther1}
                                disabled={!requiredOther1}
                                maxLength={5}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="戸"
                                currentForm={form}
                                onValidateError={changeBtnDisable}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="一棟アパート・戸建て（棟数）"
                                name="quantity02"
                                type="number"
                                required={requiredOther1}
                                disabled={!requiredOther1}
                                maxLength={5}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="棟"
                                currentForm={form}
                                onValidateError={changeBtnDisable}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={24}>
                            <FormTextArea
                                label="投資用不動産詳細（任意）"
                                name="others01"
                                disabled={!requiredOther1}
                                maxLength={1000}
                                rows={5}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12}>
                            <FormRadio
                                options={YES_NO_OPTIONS}
                                required
                                label="その他所有不動産"
                                name="existFlagPropertyOther"
                                labelClassName="content-step-form label-step-form"
                                onChange={(e) => {
                                    setRequiredOther2(e == '1');
                                }}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[0, 12]}>
                        <Col span={24}>
                            <FormTextArea
                                label="その他所有不動産詳細"
                                name="others02"
                                required={requiredOther2}
                                disabled={!requiredOther2}
                                currentForm={form}
                                onValidateError={changeBtnDisable}
                                maxLength={1000}
                                rows={5}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
